import React from "react";

import styles from "./Iframe.module.scss";

export default function iFrame({ clientErrorStatusCodes, statusCode, statusCodeMap, cdnUrl }) {
  return (
    <>
      {clientErrorStatusCodes.includes(statusCode) && (
        <div className={styles.error}>
          <div className={styles.errorText}>{statusCodeMap[statusCode]}</div>
        </div>
      )}

      {cdnUrl && <iframe src={cdnUrl} width="100%" height="100%" title="HTML Viewer" className={styles.iframe} />}
    </>
  );
}
